import React from 'react';
import { useInvalidSection } from '../metroline/invalid-section';
import { getFavouriteRoute, useFavouriteConfiguration } from '../metroline/favourite-configuration';
import { FavouriteItem } from '../types-store';
import { FavouriteFormProps } from '../types';
import { FavouriteFormRenderer } from './favourite-form-renderer';
import { displayRecipientsSection, displayScheduleSection } from 'app/area/favourite-administration/form/components/helpers';

export const FavouriteFormSections: React.FC<FavouriteFormProps> = ({
  formState, mainLanguage, shouldPrompt, options, scheduleDeleting, section, locale, translation,
  saveFavourite, deleteFavourite, updateItem, changeLanguage, copyLanguageToAll, 
  changeLongDescription, copyLongDescriptionToAll, loadOptions, clearParent,
  deleteSchedule, updateValidation, resetValidation, displayError
}) => {

  const scrollViewUrl = getFavouriteRoute(formState.favouriteItem?.id);
  const configuration = useFavouriteConfiguration(
    formState.favouriteItem?.id, 
    displayScheduleSection(formState.favouriteItem?.reportType?.value),
    displayRecipientsSection(formState.favouriteItem),
    formState.validation
    );
  const [invalidSection, updateInvalidSection] = useInvalidSection(configuration, formState.validation);

  const onSaveFavourite = (item: FavouriteItem, addOwnersToDescendants?: boolean) => {
    updateInvalidSection(undefined);
    saveFavourite(item, addOwnersToDescendants);
  };

  return <FavouriteFormRenderer
    formState={formState}
    mainLanguage={mainLanguage}
    shouldPrompt={shouldPrompt}
    saveFavourite={onSaveFavourite}
    deleteFavourite={deleteFavourite}
    clearParent={clearParent}
    updateItem={updateItem}
    changeLanguage={changeLanguage}
    copyLanguageToAll={copyLanguageToAll}
    changeLongDescription={changeLongDescription}
    copyLongDescriptionToAll={copyLongDescriptionToAll}
    options={options}
    loadOptions={loadOptions}
    updateValidation={updateValidation}
    resetValidation={resetValidation}
    displayError={displayError}
    locale={locale}
    validation={formState.validation}
    translation={translation}
    label={translation.manage_favourites_title}
    section={section}
    initialSection={section}
    configuration={configuration}
    scrollViewUrl={scrollViewUrl}
    invalidSection={invalidSection}
    scheduleDeleting={scheduleDeleting}
    deleteSchedule={deleteSchedule}
  />;
};
